module.exports = __webpack_public_path__ + "img/kjcgzh.74742a9a.svg";